var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { t, translate } from "../I18n";
import { TemporarilyUnavailableLabel } from "./TemporarilyUnavailableLabel";
import { FulfillmentTimeScope } from "../ordering";
let NotAvailableNowLabel = class NotAvailableNowLabel {
    constructor(fulfillmentTimeScope, temporarilyUnavailableLabel) {
        this.fulfillmentTimeScope = fulfillmentTimeScope;
        this.temporarilyUnavailableLabel = temporarilyUnavailableLabel;
        makeAutoObservable(this);
    }
    mkLabel(messageType) {
        const messages = {
            ASAP: translate(t.client.labels.not_available_now.text),
            OnTime: translate(t.client.labels.not_available_now.preorder_text),
        };
        return {
            message: messages[messageType],
            enabledOnClick: true,
            type: "error",
        };
    }
    label(view, unavailabilityReasons, preorderSettings) {
        if (view === "Cart" ||
            this.fulfillmentTimeScope.fulfillmentTime === null ||
            this.temporarilyUnavailableLabel.shouldAppear(unavailabilityReasons)) {
            return null;
        }
        const messageType = this.fulfillmentTimeScope.fulfillmentTime.type;
        if (unavailabilityReasons.includes("Preorder")) {
            if (preorderSettings.hasMultipleRanges ||
                preorderSettings.isSameDayOnly) {
                return this.mkLabel(messageType);
            }
        }
        else {
            if (unavailabilityReasons.includes("Schedule")) {
                return this.mkLabel(messageType);
            }
        }
        return null;
    }
};
NotAvailableNowLabel = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof FulfillmentTimeScope !== "undefined" && FulfillmentTimeScope) === "function" ? _a : Object, typeof (_b = typeof TemporarilyUnavailableLabel !== "undefined" && TemporarilyUnavailableLabel) === "function" ? _b : Object])
], NotAvailableNowLabel);
export { NotAvailableNowLabel };
